module.exports = __webpack_public_path__ + "static/media/customize_cn.a770c3aa.png";